export default function onChangePermissionGuard({
  permissionName,
  action = "UPDATE",
  onChange,
}) {
  return (newValue) => {
    if (!permissionName) return onChange(newValue);

    let user = window.loggedInUser;

    if (!user) return window.popupAlert("Autorisation refusée");

    if (user.isSuperAdmin) return onChange(newValue);

    if (!user.role) return window.popupAlert("Autorisation refusée");

    if (!user.role[permissionName])
      return window.popupAlert("Autorisation refusée");

    if (!user.role[permissionName].includes(action))
      return window.popupAlert("Autorisation refusée");

    return onChange(newValue);
  };
}
